<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Settings
    </h5>

    <div class="store-set-blk vw-pro-ux">
      <div class="store-set-ui">
        <div class="row dv-owners">
          <div class="col-lg-4 mat-crd-ui">
            Personnel profile information
            <br>
            <p> Owners have permission to see and do everything. They can also add and remove other owners </p>
          </div>

          <div class="col-lg-7 mat-crd-ui dv-email-area" *ngIf="businessDetails">
            <div class="row">
              <div class="col-lg-1">
                <img _ngcontent-c3="" alt="dashboard" id="file-image" [src]="businessDetails.ProfileImage || 'assets/img/default_user_img.png'">
              </div>
              <div class="col-lg-7 dv-usr-info">
               {{businessDetails.Name}}
                <p class="dv-mail">{{businessDetails.Email}}</p>
                <p *ngIf="businessDetails.LastLogin">{{businessDetails.LastLogin}}</p>
              </div>
              <div class="col-lg-4">
                <button class=" btn-success" mat-button [routerLink]="[ '/store/adminaccount']" >Edit personnel profile</button>
              </div>
            </div>
          </div>
          <div class="col-lg-1">

          </div>
        </div>
      </div>
    </div>
    <hr>
    <form [formGroup]="accountSettingForm" (submit)="updateAccountSetting()"
      autocomplete="off">
      <div class="store-set-blk vw-pro-ux">
        <div class="store-set-ui">
          <div class="row">
            <div class="col-lg-4 mat-crd-ui">
              Business details
            </div>

            <div class="col-lg-7 mat-crd-ui dv-email-area">
              <div class="dv-business">
                <p>Business name</p>
                <input matInput formControlName="BusinessName">
                <br>
                <p class="  ">Website </p>
                <input matInput formControlName="Website">
              </div>
            </div>
            <div class="col-lg-1">

            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="store-set-blk vw-pro-ux">
        <div class="store-set-ui">
          <div class="row">
            <div class="col-lg-4 mat-crd-ui">
              Contact information
            </div>

            <div class="col-lg-7 mat-crd-ui dv-email-area">
              <div class="dv-business">
                <p>Business email</p>
                <input matInput formControlName="BusinessEmail">
                <small>The email where all general account info will be sent.</small>
                <br>
                <p>Support email </p>
                <input matInput formControlName="SupportEmail">
                <small>The email where all support info will be sent.</small>
              </div>
            </div>
            <div class="col-lg-1">

            </div>
          </div>
        </div>
      </div>
    
      <div class="dv-sbmt-btn">
        <button class="mat-btn" mat-raised-button cdkFocusInitial [disabled]="accountSettingForm.invalid">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>